import { isRangeDefined } from "../../../pages/Workspace/utils";
import { abbreviateNumber } from "../../../utils/numberUtils";
import { FilterRange } from "./types";

/**
 * Interface for validation errors
 */
export interface ValidationErrors {
  minError: string;
  maxError: string;
}

/**
 * Parses string values to Range object
 */
export const parseRangeValues = (min: string, max: string): FilterRange => {
  const cleanMin = min === "" ? "" : min.replace(/[^\d.-]/g, "");
  const cleanMax = max === "" ? "" : max.replace(/[^\d.-]/g, "");

  return {
    min: cleanMin === "" ? undefined : Number(cleanMin),
    max: cleanMax === "" ? undefined : Number(cleanMax),
  };
};

/**
 * Formats a range value for display
 */
export const formatRangeValue = (value: number | null | undefined): string => {
  return value !== undefined && value !== null ? value.toString() : "";
};

/**
 * Validates range values and returns error messages
 */
export const validateRangeValues = (
  min: string,
  max: string
): ValidationErrors => {
  let minError = "";
  let maxError = "";

  const cleanMin = min === "" ? "" : min.replace(/[^\d.-]/g, "");
  const cleanMax = max === "" ? "" : max.replace(/[^\d.-]/g, "");

  const minNum = cleanMin === "" ? Number.NaN : Number(cleanMin);
  const maxNum = cleanMax === "" ? Number.NaN : Number(cleanMax);

  const hasMin = cleanMin !== "";
  const hasMax = cleanMax !== "";

  if (
    hasMin &&
    hasMax &&
    !Number.isNaN(minNum) &&
    !Number.isNaN(maxNum) &&
    minNum > maxNum
  ) {
    minError = "Amount must be less than the Max amount";
    maxError = "Amount must be greater than the Min amount";
  }

  return { minError, maxError };
};

export const buildRangeLabel = (range: FilterRange) => {
  const isEmptyRange = !range || !isRangeDefined(range);

  if (isEmptyRange) return "Select Range";

  //min is given and max is not given
  if (
    range.min !== undefined &&
    range.min !== null &&
    (range.max === undefined || range.max === null)
  ) {
    return `> ${abbreviateNumber(range.min as number)}`;
  }
  //max is given and min is not given
  if (
    range.max !== undefined &&
    range.max !== null &&
    (range.min === undefined || range.min === null)
  ) {
    return `< ${abbreviateNumber(range.max as number)}`;
  }

  return `${abbreviateNumber(range.min || 0)}-${abbreviateNumber(range.max || 0)}`;
};

/**
 * Checks if a range has any values (either min or max is defined)
 */
export const hasRangeValues = (range: FilterRange): boolean => {
  return range.min !== undefined || range.max !== undefined;
};
